import { FC } from "react";

import Stack from "@mui/material/Stack";

import { AmountField } from "../../RateFields/AmountField/AmountField";
import { BidIncrementField } from "../../RateFields/BidIncrementField/BidIncrementField";
import { DescriptionField } from "../../RateFields/DescriptionField/DescriptionField";
import { NameField } from "../../RateFields/NameField/NameField";
import { RateImagesField } from "../../RateFields/RateImagesField/RateImagesField";
import { ExtrasSection } from "../../shared/ExtrasSection/ExtrasSection";
import { CategoriesRow } from "../../shared/RateOptions/OptionRows/CategoriesRow";
import { TaxRow } from "../../shared/RateOptions/OptionRows/TaxRow/TaxRow";
import { useShowTaxRow } from "../../shared/RateOptions/OptionRows/TaxRow/useShowTaxRow";
import { RateOptionsGroup } from "../../shared/RateOptions/RateOptionsGroup";
import { RateCardShell } from "../../shared/RateCardShell/RateCardShell";
import { RateFieldsRow } from "../../shared/RateFieldsRow/RateFieldsRow";

import { useTranslate } from "@/common/hooks/useTranslate";

interface AuctionRateProps {
  totalCardNumber: number;
  shouldDisplayDeleteButton?: boolean;
  shouldConfirmDelete?: boolean;
  onDelete: (index: number) => void;
  onDuplicate: (index: number) => void;
  onMoveUp: (index: number) => void;
  onMoveDown: (index: number) => void;
  questionsArchivedOnDelete?: string[];
}

export const AuctionRate: FC<AuctionRateProps> = (props) => {
  const { t } = useTranslate();
  const showTaxRow = useShowTaxRow();

  return (
    <RateCardShell {...props}>
      <Stack spacing={2}>
        <Stack direction={{ xs: "column", md: "row" }} spacing={3}>
          <Stack sx={{ flexShrink: 0 }}>
            <RateImagesField />
          </Stack>
          <Stack spacing={1.5} sx={{ flex: 1, minWidth: 0 }}>
            <NameField />
            <RateFieldsRow>
              <AmountField />
              <BidIncrementField />
            </RateFieldsRow>
            <DescriptionField />
          </Stack>
        </Stack>

        <ExtrasSection
          mode="always-open"
          alwaysOpenDividerLabel={t("dashboard", "ticketing.sectionDivider.additionalOptions")}
        >
          <RateOptionsGroup title={t("dashboard", "ticketing.rateOptionsGroup.ticketType")}>
            <CategoriesRow />
          </RateOptionsGroup>
          {showTaxRow && (
            <RateOptionsGroup title={t("dashboard", "ticketing.rateOptionsGroup.taxes")}>
              <TaxRow />
            </RateOptionsGroup>
          )}
        </ExtrasSection>
      </Stack>
    </RateCardShell>
  );
};
